import React from "react";

const styles = {
  on_time: "bg-emerald-50 text-emerald-700 border-emerald-200",
  present: "bg-emerald-50 text-emerald-700 border-emerald-200",
  late: "bg-amber-50 text-amber-700 border-amber-200",
  absent: "bg-red-50 text-red-700 border-red-200",
  left_early: "bg-orange-50 text-orange-700 border-orange-200",
  overtime: "bg-blue-50 text-blue-800 border-blue-200",
  missed_clock_out: "bg-zinc-100 text-zinc-700 border-zinc-200",
  pending: "bg-zinc-100 text-zinc-700 border-zinc-200",
  approved: "bg-emerald-50 text-emerald-700 border-emerald-200",
  declined: "bg-red-50 text-red-700 border-red-200",
};

const labels = {
  on_time: "On Time",
  present: "Present",
  late: "Late",
  absent: "Absent",
  left_early: "Left Early",
  overtime: "Overtime",
  missed_clock_out: "Missed Clock-Out",
  pending: "Pending",
  approved: "Approved",
  declined: "Declined",
};

export default function StatusBadge({ status, className = "" }) {
  const s = status || "missed_clock_out";
  return (
    <span
      data-testid={`status-badge-${s}`}
      className={`inline-flex items-center px-2.5 py-0.5 text-xs font-semibold uppercase tracking-wider border rounded-sm ${styles[s] || styles.missed_clock_out} ${className}`}
    >
      {labels[s] || s}
    </span>
  );
}
